import wsApiMain from '@/services/interceptors/wsMainApi.ts';
import type { UserAuth } from '@/services/interfaces/administration/UserAuth.ts';
import type {ModuleAuth} from "@/services/interfaces/administration/ModuleAuth.ts";

export const getAuthentication = async (username: string, password: string): Promise<UserAuth> => {
  const body = { CORREO_U: username, PSW_U: password };
  const res = await wsApiMain.post('/usuario/auth', body);
  return res.data;
}

export const getModulesByRol = async (id: number): Promise<ModuleAuth[]> => {
  const res = await wsApiMain.get(`/rol/getModuloPorId_R/${id}`);
  return res.data;
}

export const recoverPassword = async (email: string) => {
  await wsApiMain.put(`/usuario/olvidoPassword/${email}`);
}